import React, { useEffect, useState } from "react";
import CustomerInfo from "../CustomerInfo";
import Grid from "@mui/material/Grid";
import { useDispatch, useSelector } from "react-redux";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Slide from "@mui/material/Slide";
import { useRouter } from "next/router";
import CancelIcon from "@mui/icons-material/Cancel";
import { booking } from "../../../redux/slices/activity";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const Index = ({ setValues, values, searchCountryCodeValue, setSearchCountryCodeValue, setFormLoading, formLoading }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const router = useRouter();
  const dispatch = useDispatch();
  const [openAdd2, setOpenAdd2] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const [bookingLoader, setBookingLoader] = useState(false);
  const [hotelinfo, setHotelInfo] = useState(null);
  const [getDetails, setGetDetails] = useState({})
  const {
    _id,
    city,
    checkIn,
    checkOut,
    choiceId,
    adult,
    child,
    senior,
    adultAmt,
    childAmt,
    seniorAmt,
    packageName,
    choiceName,
    image,
    date,
    time,
    adultOriginalPrice,
    childOriginalPrice,
    seniorOriginalPrice,
    adultOriginalAmt,
    childOriginalAmt,
    seniorOriginalAmt,
    vendorId, currency,
    vat,
    withPickup,
    extraCharge,
    // pickupPoint,
    termAndCondition,
    optionType,
    group,
    groupAmt,
    groupOriginalAmt
  } = router.query;

  const price = adult * adultAmt + child * childAmt + senior * seniorAmt;
  const OriginalPrice = adultOriginalPrice * adultOriginalAmt + childOriginalPrice * childOriginalAmt + seniorOriginalPrice * seniorOriginalAmt;
  const [totalPay, setTotalPay] = useState(price);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [pickupPoints, setPickupPoints] = useState({});
  const [errorMessage, setErrorMessage] = useState(null);
  const { bookingRes } = useSelector((state) => state.activity);


  const renderStep = () => {
    const { content } = steps[currentStep];
    return <>{content}</>;
  };

  const nextStep = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    }
  };

  useEffect(() => {
    setFormLoading(true);

    // Set a common timeout to stop formLoading after a certain delay (e.g., 2000 milliseconds or 2 seconds)
    const loadingTimeout = setTimeout(() => {
      setFormLoading(false);
    }, 2000); // Adjust the delay as needed (in milliseconds)

    return () => clearTimeout(loadingTimeout);

  }, []);

  const previousStep = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  // useEffect(() => {
  //   const { discountAmount, totalPay } = calculateDiscount(price, getDetails);
  //   setDiscountAmount(discountAmount);
  //   setTotalPay(totalPay);
  // }, [getDetails, price]);

  const handleSubmitting = async (data) => {
    // e.preventDefault();

    setBookingLoader(true);

    sessionStorage.setItem("bookingQueryUrl", JSON.stringify(router.query));
    sessionStorage.setItem("bookingFormValues", JSON.stringify(values));

    const userId = JSON.parse(sessionStorage.getItem("rslkey"));
    // Check if discountAmount fully covers the price (bypass payment)
    const skipPayment = discountAmount !== 0 && discountAmount !== '' && discountAmount !== undefined ? Number(discountAmount) === Number(price) : false;

    const obj = {
      activityId: _id,
      choiceId: choiceId,
      activityDate: date,
      activityTime: time,
      contactDetails: {
        name: values.name,
        email: values.email,
        countryCode: searchCountryCodeValue.includes("+") ? searchCountryCodeValue : `+${searchCountryCodeValue}`,
        mobile: values.phone,
        type: userId && userId !== null ? 1 : 2,
        specialRequest: values?.specialRequest
      },
      userId: userId && userId !== null ? userId : "",
      adultPrice: adultAmt,
      adultCount: adult,
      childPrice: childAmt,
      childCount: child,
      optionType: optionType,
      groupCount: group || 0,
      totalPersonCount: (Number(adult) + Number(child) + Number(senior)) || 0,
      seniorPrice: seniorAmt,
      seniorCount: senior,
      // totalPrice: (optionType == 2) ? totalPay + Number(extraCharge) + ((totalPay + Number(extraCharge)) * vat / 100) : (group * groupAmt) + Number(extraCharge) + (((group * groupAmt) + Number(extraCharge)) * vat / 100),
      totalPrice: totalPay + Number(extraCharge) + ((totalPay + Number(extraCharge)) * vat / 100),
      discountAmount: discountAmount !== undefined ? discountAmount : 0,
      actualAmount: (optionType == 2) ? adult * adultAmt + child * childAmt : (group * groupAmt),
      promoCode: getDetails?.promocode || "",
      paymentOption: skipPayment ? 0 : data?.type,
      transRef: data?.type !== 1 ? data?.data?.pre_transaction_id : "",
      pickupPoint: pickupPoints,
      extraPrice: Number(extraCharge) || 0,
      vat: vat === 0 ? 0 : Number(`${((totalPay + Number(extraCharge)) * vat) / 100}`)
    };

    setLoading(true);
    dispatch(booking(obj));
  };

  useEffect(() => {
    if (bookingRes && loading) {
      setBookingLoader(false);
      setLoading(false);
      // setIsBookNow(false)

      if (bookingRes?.status === 2) {
        setErrorMessage(bookingRes);

      } else if (bookingRes?.status === -1) {
        setErrorMessage(bookingRes);
      } else if (bookingRes?.status === 1) {
        if (bookingRes?.paymentUrl !== "") {
          sessionStorage.setItem("activityTypes", 6);

          sessionStorage.setItem("ref", bookingRes?.orderReference);
          sessionStorage.setItem("activityTypes", 6);
          router.push(bookingRes?.paymentUrl);
        } else {
          sessionStorage.setItem("activityTypes", 6);
          router.push(`/loading?normal=${bookingRes?.status}&statusin=${bookingRes?.message}&bookingId=${bookingRes?.bookingId}`);
        }
      }
      // setOpenAdd2(true);

    }
  }, [bookingRes]);

  const handleAddClose2 = () => {
    setOpenAdd2(false);
    router.push("/activities/activities");
  };

  const steps = [
    {
      title: "Personal Details",
      stepNo: "1",
      stepBar: (
        <>
          <div className="col d-none d-sm-block">
            <div className="w-full h-1 bg-border"></div>
          </div>
        </>
      ),
      content: (
        <CustomerInfo
          bookingLoader={bookingLoader}
          setValues={setValues}
          values={values}
          handleSubmitting={handleSubmitting}
          vendorId={vendorId}
          optionType={optionType}
          group={group}
          groupAmt={groupAmt}
          groupOriginalAmt={groupOriginalAmt}
          price={(optionType == 2) ? (adult * adultAmt + child * childAmt + senior * seniorAmt) : (group * groupAmt)}
          originalPrice={(optionType == 2) ? (adult * adultOriginalAmt + child * childOriginalAmt + senior * seniorOriginalAmt) : (group * groupOriginalAmt)}
          discountAmount={discountAmount}
          extraCharge={extraCharge}
          packageId={_id}
          setGetDetails={setGetDetails}
          getDetails={getDetails}
          setBookingLoader={setBookingLoader}
          bookingRes={bookingRes}
          setSearchCountryCodeValue={setSearchCountryCodeValue}
          searchCountryCodeValue={searchCountryCodeValue}
          setFormLoading={setFormLoading}
          formLoading={formLoading}
          currency={currency}
          vat={vat}
          withPickup={withPickup}
          pickupPoints={pickupPoints}
          setPickupPoints={setPickupPoints}
          termAndCondition={termAndCondition}
          adult={adult}
          child={child}
          senior={senior}
          adultAmt={adultAmt}
          childAmt={childAmt}
          seniorAmt={seniorAmt}
          errorMessage={errorMessage}
          setErrorMessage={setErrorMessage}
          totalPay={totalPay}
          setTotalPay={setTotalPay}
          activityId={_id}
        />
      ),
    },

  ];

  return (
    <>
      <Dialog
        open={openAdd2}
        TransitionComponent={Transition}
        keepMounted
        maxWidth="xl"
        onClose={handleAddClose2}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent style={{ width: "400px" }}>
          <DialogContentText id="alert-dialog-slide-description">

            <Grid container spacing={3}>
              <Grid
                item
                md={12}
                sx={{
                  position: "absolute",
                  right: 0,
                  top: -5,
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <CancelIcon
                  onClick={handleAddClose2}
                  sx={{
                    color: "#6b6b6b",
                    cursor: "pointer",
                    fontSize: 26,
                  }}
                />
              </Grid>

              <Grid item md={12} sx={{ display: "flex", justifyContent: "center" }}>
                <img src="/img/greenTick.png" alt="Success" width="100" />
              </Grid>

              <Grid item md={12} sx={{ display: "flex", justifyContent: "center" }}>
                <h3 style={{ color: "green" }}>Success</h3>
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
      </Dialog>

      <form onSubmit={handleSubmitting} style={{ marginTop: "10px" }}>
        <div className="row x-gap-40 y-gap-30 items-center">
          {steps.map((step, index) => (
            <React.Fragment key={index}>
              <div className="col-auto">
                <div
                  className="d-flex items-center cursor-pointer transition"
                  onClick={() => setCurrentStep(index)}
                >
                  <div
                    className={
                      currentStep === index
                        ? "active size-40 rounded-full flex-center bg-dark-3"
                        : "size-40 rounded-full flex-center bg-blue-1-05 text-blue-1 fw-500"
                    }
                  >
                    {currentStep === index ? (
                      <>
                        <i className="icon-check text-16 text-white"></i>
                      </>
                    ) : (
                      <>
                        <span>{step.stepNo}</span>
                      </>
                    )}
                  </div>

                  <div className="text-18 fw-500 ml-10"> {step.title}</div>
                </div>
              </div>
              {/* End .col */}

              {step.stepBar}
            </React.Fragment>
          ))}
        </div>
        {/* End stepper header part */}

        <div className="row">{renderStep()}</div>
        {/* End main content */}

        {/* <div className="row x-gap-20 y-gap-20 pt-20">
        <div className="col-auto">
          <button
            className="button h-60 px-24 -blue-1 bg-light-2"
            disabled={currentStep === 0}
            onClick={previousStep}
          >
            Previous
          </button>
        </div>

        <div className="col-auto">
          <button
            className="button h-60 px-24 -dark-1 bg-blue-1 text-white"
            disabled={currentStep === steps.length - 1}
            onClick={nextStep}
          >
            Next <div className="icon-arrow-top-right ml-15" />
          </button>
        </div>
      </div> */}

        {/* End stepper button */}
      </form>
    </>
  );
};

export default Index;
